import React from 'react'

import getCurrencySymbol from '../../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../../utilities/currency/formatPrice'

import yn from 'yn'
import _ from 'lodash'

const BkFlowRoomCardDynamicRatesToggle = props => {
  const {
    activeCurrencyData,
    cards,
    configData,
    displayedPriceFrequency,
    hotelLabels,
    isTaxInclusiveProperty,
    roomRateStageEvent,
    roomRateStageExpanded,
    totalNights,
    urlData,
  } = props

  let activeHotelCode = null
  let activeHotelPhoneNumber = null
  let matchedProperty = null
  let totalRoomRates = null
  let lowestRoomRate = null
  let currentCurrencyCode = null
  let currentCurrencySymbol = null
  let highlightedRoomRateFees = 0

  // Get hotel code from avail response
  if (
    !_.isEmpty(urlData) &&
    urlData.hotelCode
  ) {
    activeHotelCode = urlData.hotelCode
  }

  if (!_.isEmpty(configData)) {
    let configProperties = configData.hotel.options.properties
    matchedProperty = null

    if (
      configData.hotel &&
      configData.hotel.options &&
      configData.hotel.options.properties
    ) {
      configProperties = configData.hotel.options.properties
    }

    // Match activeHotelCode to config properties array
    if (!_.isEmpty(configProperties)) {
      matchedProperty = configProperties.find(function(property) {
        return property.hotelCode === String(activeHotelCode)
      })
    }

    // Set phone # by config or crs fallback
    if (
      !_.isEmpty(matchedProperty) &&
      matchedProperty.contactNumbers &&
      matchedProperty.contactNumbers.reservations
    ) {
      activeHotelPhoneNumber = matchedProperty.contactNumbers.reservations
    }
  }

  if (
    cards &&
    cards.viewExtensions &&
    cards.viewExtensions.roomRates
  ) {
    totalRoomRates = cards.viewExtensions.roomRates.length
    currentCurrencyCode = _.get(cards, '.viewExtensions.roomRates[0].rates[0].total.currencyCode', 'USD')
    currentCurrencySymbol = getCurrencySymbol(currentCurrencyCode)

    const roomRateData = []

    for (const rate in cards.viewExtensions.roomRates) {
      const currentRoomRate = cards.viewExtensions.roomRates[rate].rates[0]

      if (displayedPriceFrequency === 'per stay') {
        if (isTaxInclusiveProperty) {
          roomRateData.push(currentRoomRate.total.amountAfterTax)
        } else {
          roomRateData.push(currentRoomRate.total.amountBeforeTax)
        }
      } else {
        if (isTaxInclusiveProperty) {
          roomRateData.push(currentRoomRate.total.amountAfterTax / totalNights)
        } else {
          roomRateData.push(currentRoomRate.total.amountBeforeTax / totalNights)
        }
      }
    }

    lowestRoomRate = Math.min.apply(null, roomRateData)
    cards.viewExtensions.roomRates.forEach(room => {
      room.rates.forEach(rate => {
        rate.total.taxes.tax.forEach(fee => {
          if (fee.code === 12 && fee.amount && fee.amount > 0) {
            highlightedRoomRateFees = fee.amount;
          }
        })
      })
    });

    if (
      yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
      activeCurrencyData &&
      activeCurrencyData.exchangeRate &&
      activeCurrencyData.currencyCode
    ) {
      lowestRoomRate = lowestRoomRate * activeCurrencyData.exchangeRate

      if (activeCurrencyData.currencySymbol) {
        currentCurrencySymbol = activeCurrencyData.currencySymbol
      } else {
        currentCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
      }
    }
  }

  return (
    Number(totalRoomRates) > 0 ? (
      <div className="bk-flow-room__pricing dynamic-rates row">
          <div className="bk-flow-room__pricing-total-rates">
            <h2 className="u-remove-margin h6">
              <span className="total-rates-value">{totalRoomRates + ' '}</span>
              <span className="total-rates-label">
                { Number(totalRoomRates) === 1 ?
                  hotelLabels && hotelLabels.offerFrom ? ' ' + hotelLabels.offerFrom : 'Offer From'
                :
                  hotelLabels && hotelLabels.offersFrom ? ' ' + hotelLabels.offersFrom : 'Offers From'
                }
              </span>
            </h2>
          </div>

        { lowestRoomRate &&
          <div className="bk-flow-room__pricing-lowest-rate">
            <h2 className="u-remove-margin lowest-rate-value">
              <span className="rate-amount">
                {currentCurrencySymbol && <span className="currency-symbol">{ ' ' + currentCurrencySymbol }</span>}
                { yn(process.env.REACT_APP_COMPONENT_ROOM_CARD_PRICE_DECIMALS) ?
                  formatPrice((lowestRoomRate + highlightedRoomRateFees), 2, true)
                :
                  formatPrice((lowestRoomRate + highlightedRoomRateFees), 0, false)
                }
              </span>

              <span className="rate-frequency">
                { displayedPriceFrequency === 'per stay' ?
                  hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total'
                  :
                  hotelLabels && hotelLabels.perNight ? hotelLabels.perNight : 'Per Night'
                }
              </span>

              {highlightedRoomRateFees > 0 &&
                <span className="rate-including-fees">
                  Includes {currentCurrencySymbol}{highlightedRoomRateFees.toFixed(2)} destination fee
                </span>
              }

            </h2>
          </div>
        }

        <div className={`bk-flow-room__pricing-toggle-rates ${roomRateStageExpanded ? 'expanded' : ''}`}>
          <button
              className="btn btn-primary"
              onClick={(e) => {
                e.target.scrollIntoView({behavior: "smooth"})
                roomRateStageEvent()}}
          >
            {
              roomRateStageExpanded
                ? hotelLabels.closeRates ? hotelLabels.closeRates : 'Close Rates'
                : hotelLabels.selectRoom ? hotelLabels.selectRoom : 'Select Room'
              }
          </button>
        </div>
      </div>
    ) : (
      <div className="bk-flow-room__pricing-unavailable">
        <h4>{ hotelLabels && hotelLabels.unavailableRoomTitle ? hotelLabels.unavailableRoomTitle : 'Change in Plans?' }</h4>
        <p>
          { hotelLabels &&
          hotelLabels.unavailableRoomMessage ?
            hotelLabels.unavailableRoomMessage
            :
            'Dates can’t budge? Choose a different room. If you love this room, select different dates or call:'
          }
        </p>
        { activeHotelPhoneNumber && <a href={ 'tel:' + activeHotelPhoneNumber }>{ activeHotelPhoneNumber }</a> }
      </div>
    )
  )
}

export default BkFlowRoomCardDynamicRatesToggle



// WEBPACK FOOTER //
// ./src/components/room/elements/default/dynamic/BkFlowRoomCardDynamicRatesToggle.js